'use client';
import React, { useEffect } from 'react';

interface PlayStreamScriptProps {
  scriptType: 'homepage' | 'article';
}

export const PlayStreamScript: React.FC<PlayStreamScriptProps> = ({ scriptType }) => {
  useEffect(() => {
    const headID = document.getElementsByTagName('head')[0];
    const newScript = document.createElement('script');
    newScript.id = 'PlayStreamScriptLoader';
    newScript.defer = true;
    newScript['key'] = 'PlayStreamScriptLoader';
    newScript.type = 'text/javascript';

    const scriptSrc =
      scriptType === 'homepage'
        ? 'https://ads.playstream.media/api/adserver/scripts?PS_TAGID=67e52b2dca6f1325b648dcf6&PS_PUB_ID=67e52ab4ca6f1325b648db0a'
        : 'https://ads.playstream.media/api/adserver/scripts?PS_TAGID=67e52b54ca6f1325b648dd31&PS_PUB_ID=67e52ab4ca6f1325b648db0a';

    newScript.src = scriptSrc;
    headID.appendChild(newScript);
  }, [scriptType]);

  return null;
};
